import React, { useEffect, useState } from 'react';
import Flatpickr from 'react-flatpickr';
import PropsType from 'prop-types';

const CustomFlatpickr = ({
  time,
  setTime,
  limit,
  globalDatePicker,
  setDate,
  closeTime,
}) => {
  const renderLimitTime = () => {
    if (time?.length === 1) {
      const maxDate =
        new Date(time?.[0]).getTime() + limit * 24 * 60 * 60 * 1000 <
        new Date().setHours(0, 0, 0)
          ? new Date(time?.[0]).getTime() + limit * 24 * 60 * 60 * 1000
          : new Date();
      return {
        minDate: new Date(
          new Date(time?.[0]).getTime() - limit * 24 * 60 * 60 * 1000,
        ),
        maxDate: new Date(maxDate),
      };
    }
    if (time?.length === 2) {
      const maxDate =
        new Date(time?.[0]).getTime() + limit * 24 * 60 * 60 * 1000 <
        new Date().setHours(0, 0, 0)
          ? new Date(time?.[0]).getTime() + limit * 24 * 60 * 60 * 1000
          : new Date();
      const minDate = new Date(
        new Date(time?.[1]) - limit * 24 * 60 * 60 * 1000,
      );
      return {
        maxDate: new Date(maxDate),
        minDate,
      };
    }
    return {
      maxDate: new Date(),
    };
  };

  const onGlobalDateChange = (date) => {
    if (date?.length == 2) {
      setDate(date);
    }
  };

  const globalCloseTime = (date) => {
    if (date?.length == 1) {
      setDate([
        new Date(new Date().getTime() - 10 * 24 * 60 * 60 * 1000).setHours(
          0,
          0,
          0,
        ),
        new Date().setHours(0, 0, 0),
      ]);
    }
  };

  return (
    <Flatpickr
      value={time}
      placeholder="Select Date Range"
      onChange={globalDatePicker ? onGlobalDateChange : setTime}
      options={{
        mode: 'range',
        defaultDate: [
          new Date(new Date().getTime() - 10 * 24 * 60 * 60 * 1000),
          'today',
        ],
        dateFormat: 'd-m-Y',
        // ...renderLimitTime(),
      }}
      onClose={globalDatePicker ? globalCloseTime : closeTime}
      style={{
        fontSize: 14,
        width: 200,
      }}
      className="form-control flat-picker bg-transparent border-0 shadow-none min-width-190 "
    />
  );
};

CustomFlatpickr.defaultProps = {
  limit: 30,
};

CustomFlatpickr.prototype = {
  time: PropsType.any.isRequired,
  setTime: PropsType.func.isRequired,
  limit: PropsType.number,
};

export default CustomFlatpickr;
